import MarkdownIt from 'markdown-it'

const md = new MarkdownIt()

export const renderMarkdown = (template) => {
  if (!template || typeof template !== 'string') return ''
  return md.render(template)
}
const extractPlainText = (html) => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html

  return (tempDiv.textContent || tempDiv.innerText || '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\n\s*\n/g, '\n')
    .trim()
}
export const renderMarkdownToText = (template) => {
  if (!template || typeof template !== 'string') return ''

  const html = md.render(template)

  return extractPlainText(html)
}
const markdownPatterns = [
  /^#{1,6}\s+/m,
  /\*\*[^*\s][^*]*[^*\s]\*\*/,
  /__[^_\s][^_]*[^_\s]__/,
  /\*[^*\s][^*]*[^*\s]\*/,
  /(?<![\w@])_[^_\s][^_]*[^_\s]_(?![\w@])/,
  /```[\s\S]*?```/,
  /`[^`\s][^`]*[^`\s]`/,
  /\[[^\]]+\]\([^)]+\)/,
  /!\[[^\]]+\]\([^)]+\)/,
  /^[\s]*[-*+]\s+/m,
  /^[\s]*\d+\.\s+/m,
  /^[\s]*>\s+/m,
  /^[\s]*[-*_]{3,}[\s]*$/m,
  /\|[^|]*\|/,
  /~~[^~\s][^~]*[^~\s]~~/,
  /^[\s]*- \[ \]/m,
  /^[\s]*- \[x\]/m,
]
export const isMarkdown = (text) => {
  if (!text || typeof text !== 'string') return false

  return markdownPatterns.some((pattern) => pattern.test(text))
}
